/**
 * @file dhx-import-fix.js
 * @description Исправление импорта DHX Suite Grid класса для устранения ошибки "Grid is not a constructor"
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-15
 * @updated 2025-09-16
 * @dependencies ['@src/modules/dhx-suite/codebase/suite.js']
 * @related-files ['src/features/table/table.component.tsx']
 */

// Импортируем все экспорты DHX как namespace (без деструктуризации для избежания ошибок)
import * as dhxSuite from './codebase/suite.js';

// Функция для безопасного получения Grid конструктора
export function getDHXGrid() {
    // Проверяем различные способы доступа к Grid без деструктуризации
    if (typeof window !== 'undefined' && window.dhx && window.dhx.Grid) {
        return window.dhx.Grid;
    }

    // Проверяем глобальный dhx для ProGrid
    if (typeof window !== 'undefined' && window.dhx && window.dhx.ProGrid) {
        return window.dhx.ProGrid;
    }

    // Логируем доступные свойства для дебага только при ошибке
    console.error('DHX Grid not found. Available dhxSuite properties:', Object.keys(dhxSuite || {}));
    console.error('Available window.dhx properties:', typeof window !== 'undefined' ? Object.keys(window.dhx || {}) : 'window not available');
    throw new Error('DHX Grid constructor not found. Check DHX Suite installation.');
}

// Функция для безопасного получения Calendar конструктора
export function getDHXCalendar() {
    if (typeof window !== 'undefined' && window.dhx && window.dhx.Calendar) {
        return window.dhx.Calendar;
    }
    throw new Error('DHX Calendar constructor not found.');
}

// Функция для безопасного получения Popup конструктора
export function getDHXPopup() {
    if (typeof window !== 'undefined' && window.dhx && window.dhx.Popup) {
        return window.dhx.Popup;
    }
    throw new Error('DHX Popup constructor not found.');
}

// Функция для безопасного получения i18n объекта
export function getDHXi18n() {
    if (typeof window !== 'undefined' && window.dhx && window.dhx.i18n) {
        return window.dhx.i18n;
    }

    // Если i18n не найден, возвращаем заглушку с методом setLocale
    console.warn('DHX i18n not found. Using stub implementation.');
    return {
        setLocale: (component, translations) => {
            console.warn(`i18n.setLocale called for ${component}, but i18n is not available`);
        }
    };
}

// Экспортируем все DHX компоненты через единую функцию
export function getDHXSuite() {
    return {
        Grid: getDHXGrid(),
        Calendar: getDHXCalendar(),
        Popup: getDHXPopup(),
        i18n: getDHXi18n()
    };
}

// Экспортируем CSS также
export const DHX_CSS_PATH = './codebase/suite.min.css';